import { GENTATION } from "shared/dictionaries/gentation";
import ApiHelpers from "shared/util/ApiHelpers";
import Identity from "shared/util/Identity";

/**
 * Given a user's What I Want values (usually `wiw.values` returned by a GET to
 * `/profile/wiw_parameters`), return a list of genders in which the user is
 * interested.
 *
 * @param {dict} filters - a dictionary of the user's What I Want settings
 * @returns {array} - the list of genders in which this user is interested
 */
const GetGendersFromWiwSettings = (filters) => {
	const genderTagIds = filters.gender_tags;
	const genderTags = [];

	// if gender tag ids were provided, populate gender tags from those
	if (genderTagIds && genderTagIds.length) {
		genderTagIds.forEach((id) => {
			if (GENTATION.GENDER_TAGS[id]) {
				genderTags.push(ApiHelpers.prepareApiKey(GENTATION.GENDER_TAGS[id]));
			}
		});

	// otherwise, look at gentation
	} else if (filters.gentation) {
		const gentation = filters.gentation;
		const desired = Identity.getInterestsFromGentation(gentation);

		// if they have a gentation of 63 (everyone), push in all the gender tags
		if (gentation === 63) {
			Object.keys(GENTATION.GENDER_TAGS).forEach((tag) => {
				genderTags.push(ApiHelpers.prepareApiKey(GENTATION.GENDER_TAGS[tag]));
			});

		// if they have an i_want of 3 (aka "everyone"), it means Men and Women
		} else if (desired.i_want === 3) {
			genderTags.push(GENTATION.GENDER_MAPPINGS.full[1].toLowerCase());
			genderTags.push(GENTATION.GENDER_MAPPINGS.full[2].toLowerCase());

		// otherwise, their i_want will be either Men or Women
		} else {
			genderTags.push(GENTATION.GENDER_MAPPINGS.full[desired.i_want].toLowerCase());
		}
	}

	return genderTags;
};

export default GetGendersFromWiwSettings;



// WEBPACK FOOTER //
// ./src/shared/util/GetGendersFromWiwSettings.js